import uniq from './uniq';
var union = function () {
  var sources = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }
  return uniq([].concat.apply([], sources));
};
export default union;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/union.js
// module id = 49
// module chunks = 0